export default __webpack_public_path__ + "static/media/IconClose.a9f77bcd.svg";